var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bank-selection-flow"},[(!_vm.sourceName)?[_c('riseup-header'),_vm._v(" "),_c('bank-selection',{attrs:{"on-selection":_vm.bankSelection}})]:[(_vm.isDiscountSource)?_c('discount-flow'):_c('bank-connection-flow')]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aebb8f78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/authenticated/onboard2/steps/bank-selection/BankSelectionFlow.vue
// module id = null
// module chunks = 